export const DEVELOPER = "ROLE_TPSC_ACADEMY_DEVELOPER";
export const INSTRUCTOR = "ROLE_TPSC_ACADEMY_INSTRUCTOR";
export const WRITER = "ROLE_TPSC_ACADEMY_WRITER";
export const STUDENT = "ROLE_TPSC_ACADEMY_STUDENT";
 
interface RolesConfigModel {
    [key: string]: string | string[]
}
const RolesConfig: RolesConfigModel = {
    SCENARIO: [DEVELOPER, STUDENT, INSTRUCTOR, WRITER],
    SHOW_REVIEW: [DEVELOPER, INSTRUCTOR, WRITER],
    SHOW_START: [DEVELOPER, STUDENT],
    SHOW_OPEN: [DEVELOPER, WRITER],
    SHOW_DELETE: [DEVELOPER, WRITER],
    SHOW_SUBMIT: [DEVELOPER, STUDENT],
    SHOW_PRACTICE: [DEVELOPER, STUDENT],
    CREATE_SCENARIO: [DEVELOPER, WRITER],
    SCENARIO_PUBLISH: [DEVELOPER, WRITER]
    
};

// Define a priority order for roles
const ROLE_PRIORITY = [DEVELOPER, WRITER, INSTRUCTOR ,STUDENT];

const selectRoleByPriority = (roles: string[]): string | null => {
    for (const priorityRole of ROLE_PRIORITY) {
        if (roles.includes(priorityRole)) {
            return priorityRole; // Return the highest-priority role
        }
    }
    return null; // Return null if no matching role is found
};

const checkRoleHasAccess = (roles: string[], key: string) => {
    if (RolesConfig[key] && RolesConfig[key].length) {
        return roles.filter((role) => RolesConfig[key].includes(role)).length > 0;
    }
    //access allowed if no roles specified
    return true;
};

export { RolesConfig, checkRoleHasAccess, selectRoleByPriority };
